import React, { useState } from "react";
import * as Yup from "yup";
import { Formik, FormikErrors } from "formik";
import { useSignupSubscriber } from "hooks/api/useSignupSubscriber";
import { useRecordNewsletterSubscribed } from "hooks/analytics/useRecordNewsletterSubscribed";

export function NewsletterSignupForm({ children }) {
  interface FormValues {
    email: string;
  }

  const initialFormValues: FormValues = {
    email: "",
  };

  const formValidationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Your email isn't formatted correctly")
      .required("You forgot to write your email"),
  });

  interface FormErrors {
    email: string;
    signupSubscriberError: string;
  }

  function someFieldHasError(errors: FormikErrors<FormErrors>) {
    return Boolean(errors?.email) || Boolean(errors?.signupSubscriberError);
  }

  function getErrorMessage(errors: FormikErrors<FormErrors>) {
    return errors?.email ?? errors?.signupSubscriberError;
  }

  const { signupSubscriber } = useSignupSubscriber();
  const recordNewsletterSubscribed = useRecordNewsletterSubscribed();
  const [signedUpSuccessfully, setSignedUpSuccessfully] = useState(false);

  async function onSubmit(values, { setErrors, setSubmitting }) {
    const { email } = values;
    const { signupSubscriberError, subscriberId } = await signupSubscriber(
      email
    );
    if (signupSubscriberError) {
      setErrors({
        signupSubscriberError,
      });
      return setSubmitting(false);
    } else {
      recordNewsletterSubscribed(email, "homepage", subscriberId);
    }

    setSignedUpSuccessfully(true);
  }

  const [formShown, setFormShown] = useState(true);

  return (
    <Formik
      initialValues={initialFormValues}
      onSubmit={onSubmit}
      validationSchema={formValidationSchema}
    >
      {(formProps) =>
        children({
          ...formProps,
          signedUpSuccessfully,
          getErrorMessage,
          someFieldHasError,
          formShown,
          setFormShown,
        })
      }
    </Formik>
  );
}
